/**
 * exports the parameter definitions and route definitions
 */

export * from './default/parameter-definition';
export {routesDefinition} from './routes/routes-definition';
export {commonParameterDefinition} from './routes/common-parameter-definition';
export {bffEnvVariablesDefinition} from './env-definition';
